/**
 * The US states and DC, code and name, for the State box on the Answers
 * page. Mirrors the table in @jobcork/apply (timezone.ts), which the fill
 * reads the state from; kept here so the web app does not import the
 * package (see fillHint.ts).
 */
export const US_STATES: ReadonlyArray<readonly [string, string]> = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"],
  ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"],
  ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"],
  ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"],
  ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"],
  ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];

/**
 * The one saved "City and state" line ("Nashville, TN") as its two boxes, and
 * back. The fill, the location pickers and the time zone all read the state
 * from the part after the last comma, so the two boxes are joined that way.
 */
export function splitCityState(homeCity: string | null | undefined): { city: string; state: string } {
  const raw = (homeCity ?? "").trim();
  const at = raw.lastIndexOf(",");
  if (at < 0) return { city: raw, state: "" };
  return { city: raw.slice(0, at).trim(), state: raw.slice(at + 1).trim() };
}

export function joinCityState(city: string, state: string): string {
  const c = city.trim();
  const s = state.trim();
  return s ? `${c}, ${s}` : c;
}

/** Whether the saved line names a state at all: something after a comma. */
export function hasState(homeCity: string | null | undefined): boolean {
  return splitCityState(homeCity).state.length >= 2;
}
